import { Legal } from "@/pages/Legal/Legal.page";

export default Legal;
